<template>
  <div class="fin-my-profile" style="background-color: #fff;">
    <template v-if="!$route.meta.newPage && profile && profile.id && user">
      <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                   v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                   class="myProfile fin-color-primary-dark"
                   fluid>
        <v-row>
          <v-col cols="4" md="2" offset-md="1" sm="3">
            <fin-profile-image-editor :avatar-size="avatarSize"
                                      :class="$vuetify.breakpoint.smAndUp && profile.lastname && profile.firstname ? 'mb-n10' : ''"/>
          </v-col>
          <v-col align-self="center" cols="8" md="6" sm="6">
            <p v-if="profile.firstname && profile.lastname"
               class="fin-color-primary-light--text headline-light mb-1">
              {{ profile.firstname }} {{ profile.lastname }}
            </p>
            <p class="fin-color-primary-light--text">
              <fin-current-user-name class="fin-color-primary-light--text"/>
            </p>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="fin-color-page-background">
        <v-row dense>
          <v-col cols="12">
            <fin-tabs v-if="tabItems"
                      :background-color-tabs="$finColors.background"
                      :no-item-content-padding="true"
                      :no-item-title-padding="true"
                      :selected-tab="$route.params.tab ? tabItems.findIndex(t => t.urlParam === $route.params.tab) : 0"
                      :tab-items="tabItems"
                      @tabChanged="val => tabChanged(val)">
              <template #0>
                <fin-profile-data/>
              </template>
              <template #1>
                <fin-user-account/>
              </template>
              <template #2>
                <fin-user-subscription :active="currentTab === 2"/>
              </template>
              <template #3>
                <fin-user-payments/>
              </template>
              <template #4>
                <fin-user-documents/>
              </template>
              <template #5>
                <fin-legal-information/>
              </template>
            </fin-tabs>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <router-view v-else/>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import FinProfileImageEditor from '@/components/pages/profile/ProfileImageEditor'
import FinProfileData from '@/components/pages/profile/ProfileData'
import FinUserAccount from '@/components/pages/profile/UserAccount'
import FinCurrentUserName from '@/components/auth/CurrentUserName'
import FinTabs from "@/components/common/Tabs"
import FinUserSubscription from "@/components/pages/profile/subscription/Subscription"
import FinUserDocuments from "@/components/pages/profile/Documents"
import FinLegalInformation from "@/components/pages/profile/LegalInformation"
import FinUserPayments from "@/components/pages/profile/payments/Payments"

export default {
  name: 'fin-my-profile',
  components: {
    FinUserPayments,
    FinLegalInformation,
    FinUserDocuments,
    FinUserSubscription,
    FinTabs,
    FinCurrentUserName,
    FinUserAccount,
    FinProfileData,
    FinProfileImageEditor
  },
  data() {
    return {
      changePasswordDialog: false,
      changeUserNameDialog: false,
      tabItems: undefined,
      currentTab: 0
    }
  },
  computed: {
    ...mapState({
      profile: state => state.auth.profile,
      user: state => state.auth.user
    }),
    ...mapGetters('auth', ['groupPriceModel']),
    avatarSize() {
      const bpName = this.$vuetify.breakpoint.name

      if (bpName === 'xs') {
        return 80
      } else if (bpName === 'sm') {
        return 100
      } else if (bpName === 'md') {
        return 100
      } else {
        return 150
      }
    }
  },
  methods: {
    tabChanged(val) {
      this.currentTab = val
    }
  },
  mounted() {
    this.tabItems = [
      {name: "Profildaten", urlParam: 'profile'},
      {name: "Nutzerkonto", urlParam: 'account'},
      {name: 'Mein Abo', urlParam: 'subscription'},
      {
        name: 'Meine Zahlungen',
        urlParam: 'payments',
        hidden: this.groupPriceModel && this.groupPriceModel.id === 'TRIAL'
      },
      {name: 'Meine Dokumente', urlParam: 'documents'},
      {name: 'Rechtliches', urlParam: 'legal'}
    ]
  }
}
</script>

<style scoped lang="scss">

</style>
